import React from 'react';
import {
	Button, ButtonAppearance, UrlIcon, useOpen,
} from '@aleph/shared-components';
import RedditReportLinkingModal from 'wb-reddit/app/routes/reports/components/linking';
import { ReportRow } from 'wb-reddit/app/routes/reports/utils';

interface IProps {
	report: ReportRow
}

function ReportLinking({ report }: IProps) {
	const [linkingOpen, { onOpen: onOpenLinking, onClose: onCloseLinking }] = useOpen(false);

	return (
		<>
			{
				linkingOpen && (
					<RedditReportLinkingModal
						isOpen={linkingOpen}
						report={report}
						onClose={onCloseLinking}
					/>
				)
			}
			<Button
				leftNode={<UrlIcon />}
				appearance={ButtonAppearance.GHOST}
				onClick={onOpenLinking}
				data-testid="link-report-button"
			/>
		</>
	);
}

export default ReportLinking;
